export interface FieldMetaLike {
  isTouched?: boolean;
  isValid?: boolean;
  errors?: unknown;
}

/** Normalize TanStack Form errors to FieldError-compatible format. */
export function toFieldErrors(errors: unknown): Array<{ message?: string } | undefined> {
  if (!Array.isArray(errors)) {
    return [];
  }
  return errors.map((e) => {
    if (typeof e === 'string') {
      return { message: e };
    }
    if (
      e &&
      typeof e === 'object' &&
      'message' in e &&
      typeof (e as { message?: unknown }).message === 'string'
    ) {
      return { message: (e as { message: string }).message };
    }
    return { message: String(e) };
  });
}

/** Extract validation state from field meta. */
export function getFieldState(meta: unknown): {
  isInvalid: boolean;
  errors: ReturnType<typeof toFieldErrors>;
} {
  const m = meta as FieldMetaLike;
  const isInvalid = Boolean(m.isTouched) && m.isValid === false;
  return { isInvalid, errors: isInvalid ? toFieldErrors(m.errors) : [] };
}
